// extracted by mini-css-extract-plugin
export default {"mobileDrawerContainer":"RemoveDriverModal_mobileDrawerContainer__EpsAT"};